import { useState, useEffect } from 'react';
import Button from '../../components/button/button.component';

import axios from 'axios';
import './weather-app.styles.scss';

import WeatherCard from './componets/weather-card/weather-card.component';
import CurrentWeather from './componets/current-weather/current-weather.component';
import SearchBar from './componets/search-bar/search-bar.component';

const WeatherApp = () => {
  const [location, setLocation] = useState('');
  const [weatherData, setWeatherData] = useState(null);

  useEffect(() => {
    if (location) {
      const fetchData = async () => {
        const { data } = await axios.get(
          `https://api.openweathermap.org/data/2.5/forecast?q=${location}&cnt=6&appid=63532c58375aff8f65651a0649f5834b&units=metric`
        );
        setWeatherData(data);
        console.log(data);
      };
      fetchData();
    }
  }, [location]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const { value } = e.target.loc;
    setLocation(value);
    console.log(value);
  };

  const rows = [];
  for (let i = 1; i < 6; i++) {
    rows.push(<WeatherCard key={i} weatherData={weatherData} arrNr={i} />);
  }

  return (
    <div className='weather-app'>
      <Button btnText='Return Back' />
      <div className='container'>
        <SearchBar handleSubmit={handleSubmit} />
        {weatherData && (
          <div className='weather-container'>
            <CurrentWeather weatherData={weatherData} />
            <div className='weather-card-container'>{rows}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default WeatherApp;
